module.exports = __webpack_public_path__ + "static/media/Corona-Hinweis-Kl2.0771391a.jpg";